import { Component, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../../services/navigation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-form-tabs',
  templateUrl: './form-tabs.component.html',
  styleUrls: ['./form-tabs.component.scss']
})
export class FormTabsComponent implements OnDestroy {

  currentTab = 'application-form';
  private usanTabSubscription: Subscription
  ;
  constructor(protected navigationService: NavigationService) {
    this.usanTabSubscription = this.navigationService.getUsanFormTabUpdate().subscribe(
      changedTab => {
        this.currentTab = changedTab.value;
      });
  }

  public changeTab(selectedTab: string) {
    this.navigationService.sendUsanFormTabUpdate(selectedTab, true);
  }

  ngOnDestroy(): void {
    this.usanTabSubscription.unsubscribe();
  }

}
